module.exports = "<p>\r\n  tratos works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/tratos/tratos.component.html
// module id = ../../../../../src/app/components/tratos/tratos.component.html
// module chunks = main